import styled from "styled-components";

export const Img = styled.img`
    width: ${props => props.width !== '' ? props.width + 'px' : '100%'};
    height: ${props => props.height  !== '' ? props.height + 'px' : '122px'};
`;